module.exports = __webpack_public_path__ + "static/media/man-group.a724f7b4.jpg";